<div class="width-100">
  <div [ngClass]="{ 'adv-header': !embeddedComponent, 'adv-header-comp-class': embeddedComponent }">
    <span
      [ngClass]="{
        'adv-header-label': !embeddedComponent,
        'adv-header-label-comp-class': embeddedComponent
      }"
    >
      <a tabindex="0" (click)="toggleFilter()" (keyup.enter)="toggleFilter()"
        >{{ filter?.title }}
      </a>
      <i
        class="range-inputs-tooltip fa fa-question-circle-o"
        aria-hidden="true"
        matTooltip="Select a filter below or enter a range"
        [matTooltipPosition]="'right'"
      >
      </i>
    </span>
    <span class="adv-header-icon pull-right">
      <i
        title="{{ show ? 'Compress' : 'Expand' }} {{ filter.title }}"
        tabindex="0"
        [ngClass]="show ? 'fa fa-compress' : 'fa fa-expand'"
        (click)="toggleFilter()"
        (keyup.enter)="toggleFilter()"
      >
      </i>
    </span>
    <div
      [ngClass]="{
        'range-inputs': !embeddedComponent,
        'range-inputs-comp-class': embeddedComponent
      }"
    >
      <form (ngSubmit)="validForm(customRangeForm)" [formGroup]="customRangeForm">
        <input type="text" formControlName="from" />
        <span> to </span>
        <input type="text" formControlName="to" />
        <button type="submit" class="btn btn-primary" title="perform custom range filter">
          <i class="fa fa-chevron-right"></i>
        </button>
        <i
          class="range-inputs-tooltip fa fa-lg fa-question-circle-o"
          aria-hidden="true"
          [matTooltip]="tooltip"
          [matTooltipPosition]="'right'"
        ></i>
      </form>
    </div>
  </div>
  @if (show) {
    <div class="adv-fields">
      <ul class="target-list">
        <li class="target-heading">
          <ul class="target-list-ul" style="clear: both; display: inline-block; width: 100%">
            @for (options of filter?.dropdownFields; track options) {
              <li
                [ngClass]="{
                  'target-list-li col-12': true,
                  'col-md-6 col-lg-4': !embeddedComponent
                }"
              >
                <label>
                  <input
                    type="checkbox"
                    [class]="'filter' + filter?.filterId"
                    [value]="options.value"
                    [name]="options.name"
                    [checked]="options.selected"
                    (change)="selectFilter($event)"
                  />
                  <span></span>
                  <span
                    >{{ options.name }} <small>( {{ options.count }} )</small></span
                  >
                </label>
              </li>
            }
          </ul>
        </li>
      </ul>
    </div>
  }
</div>
